module.exports = __webpack_public_path__ + "media/site/images/key-features/screenshots/desktop-project-settlement-a3cb423798db1bf50dbd854036d52525.png";